'use strict';

import {States} from './AppConstants';

//==================================================================
// Functions dealing with store state
//===================================================================

/**
 * Examines a state object in the format:
 *
 *    {s1: States.done, s2: States.done, s3: States.done}
 *
 * .. and returns an aggregate state where if any state is 'pending'
 * the aggregate state is 'pending'. If all states are 'done' then the
 * aggregate state is 'done'. If any state is 'error' but none are
 * 'pending' then the aggregate state is 'error'; unless the allows
 * errors param is set to true, in which case the aggregate state is
 * done when all states are either done or error. The error case
 */
export const getAggregateState = (states, allowErrors = false) => {
    // build a list of all states, but filter out any state that is not a defined app constant state
    const stateValues = Object.values(states).filter(state => Object.values(States).includes(state));

    if ( stateValues.length) {
        // If all states are initial, return initial
        if ( stateValues.every(state => state === States.initial) ) {
            return States.initial;
        }

        // If any state is initial or pending, return pending
        if ( stateValues.some(state => state === States.initial || state === States.pending) ) {
            return States.pending;
        }

        // If any state is maintenance, return maintenance
        if ( stateValues.includes(States.maintenance) ) {
            return States.maintenance;
        }

        // If any state is unauthenticated, return unauthenticated
        if ( stateValues.includes(States.unauthenticated) ) {
            return States.unauthenticated;
        }

        // If any state is unauthorized, return unauthorized
        if ( stateValues.includes(States.unauthorized) ) {
            return States.unauthorized;
        }

        // If all states are done, return done
        if ( stateValues.every(state => state === States.done) ) {
            return States.done;
        }

        // If all states are error, return error
        if ( stateValues.every(state => state === States.error) ) {
            return States.error;
        }

        // If any state is error...
        if ( stateValues.includes(States.error) ) {
            if (allowErrors) {
                // allowErrors lets the aggregate be done (component might need to handle the error case)
                // if all states are error, then the aggregate will be error, but if just some are error and some are done, then state is done.
                return States.done
            } else {
                // strictly return error if any state is error
                return States.error
            }
        }
    } else {
        // if all the states passed are not in the app constant states, return error.
        return States.error;
    }
};